import { Route } from '@angular/router';

import { applicationRouteNames } from '../../app/application-route-names';
import { MpsRoleHelper } from '../../app/helpers/mps-role.helper';
import { MpsUser } from '../../app/models/mps-user.model';
import { MpsIRoutesRules } from '../interfaces/mps-routes-rules.interface';

export class MpsPermissionHelper {
  // Use properties 'forbiddenRoles' or 'allowedRoles' to define user page access.
  // Use property 'forbiddenRoles' to deny access to user having those specifics roles :
  // { routepath: routeNames.home, forbiddenRoles: [RoleHelper.PARTNER] },
  // Use property 'allowedRoles' to give access only to user having those specifics roles :
  // { routepath: routeNames.home, allowedRoles: [RoleHelper.OWNER, RoleHelper.ADMIN, RoleHelper.SUPERADMIN] },

  static readonly routesRules: MpsIRoutesRules[] = [
    {
      routepath: applicationRouteNames.courrier.index,
      allowedRoles: [MpsRoleHelper.ADMIN_IT, MpsRoleHelper.COURRIER_AGENT, MpsRoleHelper.ADMIN_METIER],
    },
    {
      routepath: applicationRouteNames.administration,
      allowedRoles: [MpsRoleHelper.ADMIN_IT, MpsRoleHelper.ADMIN_METIER, MpsRoleHelper.COURRIER_AGENT],
    },
    { routepath: applicationRouteNames.users, allowedRoles: [MpsRoleHelper.ADMIN_IT] },
    { routepath: applicationRouteNames.lokalise, allowedRoles: [MpsRoleHelper.ADMIN_IT] },
    { routepath: applicationRouteNames.allowedCities, allowedRoles: [MpsRoleHelper.ADMIN_IT] },
    {
      routepath: applicationRouteNames.rolesPermissions.index,
      allowedRoles: [MpsRoleHelper.ADMIN_IT, MpsRoleHelper.ADMIN_METIER, MpsRoleHelper.COURRIER_AGENT],
    },
    {
      routepath: applicationRouteNames.recipientGroups.index,
      allowedRoles: [MpsRoleHelper.ADMIN_IT, MpsRoleHelper.ADMIN_METIER, MpsRoleHelper.COURRIER_AGENT],
    },
    {
      routepath: applicationRouteNames.performance,
      allowedRoles: [MpsRoleHelper.ADMIN_IT, MpsRoleHelper.ADMIN_METIER],
    },
    // "Mon courrier", "Courrier délégué" and "Paramètres & aide" are available to every
    // authenticated user (regular users, admins and agents alike) and render last in the menu.
  ];

  static canUserActivate(user: MpsUser, route: Route) {
    const routeRule = this.routesRules.find((r) => r.routepath === route.path);
    if (routeRule) {
      if (routeRule.forbiddenRoles && routeRule.forbiddenRoles.length > 0) {
        return this.hasNotRole(user, routeRule.forbiddenRoles);
      } else if (routeRule.allowedRoles && routeRule.allowedRoles.length > 0) {
        return this.hasAnyRole(user, routeRule.allowedRoles);
      } else {
        return true;
      }
    }
    return true;
  }

  static isAdmin(user: MpsUser): boolean {
    return user.role !== null && user.isAdmin();
  }

  static hasAnyRole(user: MpsUser, rolesList: string[]) {
    return user.role && rolesList.includes(user.role.code.toUpperCase());
  }

  static hasNotRole(user: MpsUser, rolesList: string[]) {
    return user.role && !rolesList.includes(user.role.code.toUpperCase());
  }
}
